import moneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import { connect } from "react-redux";
export default connect(state => ({
  value: state.revenueDetails.allRevenues.totalRevenueMTDYearAgo,
  color: "#92bef4",
  currency: state.revenueDetails.allRevenues.currencySymbol,
  url: state.revenueDetails.allRevenues.totalRevenueMTDYearAgoRawDataLink,
  size: 44,
  disableAnimation: state.revenueDetails.currentUser.qa
}))(moneyDisplay);
